<template>
  <div>
    <v-list v-if="conversations.length" dense nav color="transparent">
      <conversation-list-item
        v-for="conversation in conversations"
        :key="conversation.id"
        :conversation="conversation"
        :current-conversation-id="currentConversationId"

      />
    </v-list>
    <p v-else class="text-center overline grey--text">Aucune Entrée</p>
  </div>
</template>

<script>
import ConversationListItem from './ConversationListItem.vue'
export default {
  components: { ConversationListItem },
  name: 'ConversationList',
  props: {
    conversations: {
      type: Array,
      required: true
    },
    currentConversationId: {
      type: [String, Number],
      required: false
    }
  }

}
</script>

<style lang="scss" scoped>
</style>